module.exports = __webpack_public_path__ + "static/media/D51.90572bb3.svg";